import { GlobalNavSubMenuColCardStoryblok } from '@/lib/types/component-types-sb'
import { cn } from '@/lib/utils'
import { ComponentProps } from 'react'
import { StoryblokImage } from '../storyblok-image'
import { StoryblokLink } from '../storyblok-link'

export function NavSubmenuCard({
  col,
  className,
  ...props
}: { col: GlobalNavSubMenuColCardStoryblok } & ComponentProps<typeof StoryblokLink>) {
  return (
    <StoryblokLink
      link={col.target}
      className={cn('px-3', className)}
      {...props}
    >
      <div className="bg-accent relative mb-3 h-44 w-full overflow-hidden rounded-md lg:h-36">
        {col.image.filename && (
          <StoryblokImage
            image={col.image}
            cropWidth={600}
            className="absolute bottom-0 left-0 h-full w-full object-cover object-center"
          />
        )}
        <span className="text-accent-foreground absolute bottom-2.5 left-2.5 text-sm font-medium">
          {col.imageTitle}
        </span>
      </div>
      <p className="text-muted-foreground text-xs">{col.description}</p>
    </StoryblokLink>
  )
}
